import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { apiPaths } from '../../../service/apiPaths';
import ApiService from '../../../service/ApiService';
import {
    DOC_BASE_URL, formatDateToISODateString, limit, updateComponent, ViewType
} from '../../../util/constant';
import { IDocument } from './Document.props';

interface Tag {
  id: string;
  name: string;
}

const useDocument = () => {
  const [selectedDocumentView, setSelectedDocumentView] = useState<
    string | null
  >(null);
  const [selectedDocumentId, setSelectedDocumentId] = useState<string | null>(
    null
  );
  const [documentData, setDocumentData] = useState<IDocument[]>([]);
  const [search, setSearch] = useState<string>("");
  const [page, setPage] = useState<number>(1);
  const [totalPage, setTotalPage] = useState<number>(1);
  const [loading, setLoading] = useState<boolean>(false);
  const [viewDocument, setViewDocument] = useState<any>();
  const [viewVideo, setViewVideo] = useState<any>();
  const [tags, setTags] = useState<Tag[]>([]);
  const [selectedTag, setSelectedTag] = useState<string>("");

  const navigate = useNavigate();

  const fetchTags = async () => {
    try {
      const response = await ApiService({
        method: "GET",
        endpoint: apiPaths.tags,
      });
      setTags(response || []);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchTags();
  }, []);

  useEffect(() => {
    handleDateFilter();
  }, [selectedTag]);

  const handleDateFilter = async () => {
    setLoading(true);
    try {
      let endpoint = `${apiPaths.getDocument}`;
      if (selectedTag) {
        endpoint += `?tag=${selectedTag}`;
      }

      const result = await ApiService({
        method: "GET",
        endpoint: endpoint,
      });
      setDocumentData(result);
      setTotalPage(result.totalPage);
    } catch (error) {
      console.error("Error fetching filtered data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (id: string) => {
    setSelectedDocumentId(id);
  };

  const handleAdd = () => {
    navigate("/addDocument");
  };
  const updateScreen = (type: ViewType) => {
    updateComponent(type, setSelectedDocumentView, setSelectedDocumentId);
  };
  const onchangeView = (name: string) => {
    const document = documentData.find((doc) => doc.link === name);
    console.log("document",document)
    if (document && document.link) {
      setViewDocument(document.link);
    } else {
      console.error("Document not found or link is missing");
      setViewDocument("");
    }
    if (document && document.video) {
      setViewVideo(document.video);
    } else {
      console.error("Video not found or link is missing");
      setViewVideo("");
    }
    
  };

  return {
    selectedDocumentView,
    selectedDocumentId,
    documentData,
    handleAdd,
    handleEdit,
    handleDateFilter,
    updateScreen,
    loading,
    setSearch,
    search,
    setPage,
    page,
    totalPage,
    onchangeView,
    viewDocument,
    tags,
    selectedTag,
    setSelectedTag,
    setViewDocument,
    setViewVideo,
    viewVideo,
  };
};

export default useDocument;
